import { Accordion as MantineAccordion } from '@mantine/core'
import { Link } from 'react-router-dom'

import useSidebar from '../hooks/useSidebar'

interface AccordionItem {
  value: string
  description: string | AccordionItem[]
}

function Accordion({ items }: { items: AccordionItem[] }) {
  const { close } = useSidebar()
  return (
    <MantineAccordion unstyled>
      {items.map((item) => (
        <MantineAccordion.Item key={item.value} value={item.value} className='pt-2 pl-4'>
          {typeof item.description === 'string' ? (
            <Link to={item.description} onClick={close}>
              {item.value}
            </Link>
          ) : (
            <>
              <MantineAccordion.Control className='w-full flex flex-row-reverse justify-between items-center'>
                {item.value}
              </MantineAccordion.Control>
              <MantineAccordion.Panel>
                <Accordion items={item.description} />
              </MantineAccordion.Panel>
            </>
          )}
        </MantineAccordion.Item>
      ))}
    </MantineAccordion>
  )
}

export default Accordion
